.bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 6;
  padding: 0 4px 8px;
  background: linear-gradient(
    to top,
    rgba(5, 6, 7, 0.92) 0%,
    rgba(5, 6, 7, 0.55) 42%,
    rgba(5, 6, 7, 0) 100%
  );
  transition: opacity 0.22s ease, visibility 0.22s ease;
}

.visible {
  opacity: 1;
  visibility: visible;
}

.hidden {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px 2px;
  gap: 8px;
}

.left,
.right {
  display: flex;
  align-items: center;
  gap: 2px;
  min-width: 0;
}

.icon {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border: 0;
  background: transparent;
  color: #fff;
  cursor: pointer;
  border-radius: 10px;
  flex-shrink: 0;
  transition: background 0.15s ease, transform 0.15s ease;
}

.icon:hover {
  background: rgba(255, 255, 255, 0.1);
}

.icon:active {
  transform: scale(0.94);
}

.adLabel {
  color: #ff4d5a;
  font-size: 11px;
  font-weight: 700;
  margin-left: 8px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.live {
  border: 0;
  background: linear-gradient(135deg, #e11d2e, #ff4d5a);
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  padding: 4px 9px;
  border-radius: 6px;
  margin-left: 8px;
  cursor: pointer;
  box-shadow: 0 0 0 1px rgba(225, 29, 46, 0.35);
}

.qualityChip,
.sleepChip {
  margin-left: 8px;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(8px);
}

.qualityChip {
  color: #e8eaed;
  background: rgba(255, 255, 255, 0.08);
}

.sleepChip {
  color: #ffd166;
  background: rgba(255, 209, 102, 0.12);
  font-variant-numeric: tabular-nums;
}

@media (max-width: 560px) {
  .adLabel,
  .qualityChip,
  .sleepChip {
    display: none;
  }
}
